import React, { useState, useEffect } from 'react';
import DataProvider from '../DataProvider';
import { Checkbox } from '@material-ui/core';
import './Organization/OrgPopup.css'

const AddExisting = (props) => {
    const data = props.orgrecord
    const [filter, setFilter] = useState({ orgId: data.id });
    const [searchValues, setSearchvalues] = useState()

    useEffect(() => {
        getData()
    }, [filter, props.selected]);

    const getData = async () => {
        if (!filter.orgId) delete filter.orgId
        const recordData = await DataProvider.getList(props.target, {
            pagination: { page: 1, perPage: 500 },
            sort: { field: 'id', order: 'ASC' },
            filter: filter
        })
        const values = [...recordData.data]
        if (searchValues !== values)
            setSearchvalues(values)
    }

    function toggleOrgFilter() {
        const newFilter = filter
        if (!newFilter.orgId) newFilter.orgId = data.id
        else delete newFilter.orgId
        
        setFilter(newFilter)
        getData()
    }

    function handleChange(evt) {
        const newFilter = filter
        newFilter[props.filterword || 'name'] = evt.target.value
        setFilter(newFilter)
        getData()
    }

    async function handleAddItem(id) {
        const updateData = { id: data.id, data }
        updateData.data[props.targetresource + "_to_add"] = [id]
        data[props.targetresource + "_to_remove"] = []
        await DataProvider.update('organizations', updateData)
        props.handleupdate()
    }


    function createRows() {
        let selectedIds = props.selected ? props.selected.map(item => item.id) : []

        if (searchValues) {
            return searchValues.map((item, index) => {
                if (!selectedIds.includes(item.id))
                    return (
                        <div className="table-row" key={item.id} value={item.id}>
                            {item[props.filter || 'name']}
                            <div
                                style={{ color: '#03a9f4', position: 'absolute', right: '10px', fontWeight: 'bold' }}
                                onClick={() => handleAddItem(item.id)}
                            >
                                ADD
                            </div>
                        </div>
                    );
            });
        } else {
            return <div></div>;
        }
    }


    return (<div>
        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
            <input class="popup-filter" onChange={handleChange} placeholder="Filter Name:" />
            <div style={{ fontSize: '16px', fontWeight: 500 }}>
                Filter by Organization <Checkbox
                    checked={filter.orgId}
                    onClick={toggleOrgFilter} />
            </div>
        </div>
        <div class="existing-table">{createRows()}</div>
    </div>)
}

export default AddExisting
